import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
// import MenuItem from '@material-ui/core/MenuItem'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { useHistory } from 'react-router-dom'
import {
  calculateDistance
  //editAllowance
} from '../../actions/index'
import SummaryTableComponent from './summaryTable.component'
import { Translation } from 'react-i18next'
import { allowanceValidate } from '../../containers/validate'
import AddToInvoice from './addToInvoice.component'
import {
  useForm,
  Form,
  Field,
  useFieldArray,
  WatchField,
  useWatch,
  isEmpty
} from '../../form'
import CountrySelectField from '../common/countrySelectField'
import Consent from './consent.component'
import AllowanceRoute from './newAllowanceRoute.component'
import { useDispatch } from 'react-redux'
import {
  getFullDayAllowanceValues,
  getPartDayAllowanceValues,
  getMealAllowanceValues,
  getDaysAndHours,
  createMenuItems
} from '../../utils/expense.utils'
import AllowancePassenger from './newAllowancePassenger.component'
import { GenericNumberInput } from '../../utils/numberFormat'
//import { scrollToTarget } from '../../utils/scrollTo'
import mobileView from '../../utils/mobile.utils'

const poweredByGoogle = '../../images/poweredByGoogle.png'

class NewAllowanceComponent extends React.Component {
  componentDidMount() {
    this.props.loadAllowanceCost(new Date().getFullYear())
    this.props.getUserCompanyUpdateInfo()
  }

  render() {
    return <NewAllowance {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  root1: {
    maxWidth: '100%',
    marginTop: '0px',
    overflowX: 'auto',
    padding: '0px 10px 0px 0px'
  },
  table: {
    minWidth: 200
  },
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e',
    borderBottom: 0
  },
  button: {
    [theme.breakpoints.down('400')]: {
      marginTop: 10
    }
  },
  editButton: {
    marginLeft: 10
  },
  button1: {
    margin: theme.spacing(1),
    whiteSpace: 'nowrap'
  },
  passengerBtn: {
    margin: '20px 0',
    float: 'right'
  },
  select: {
    lineHeight: '1.5',
    fontSize: '14px',
    fontWeight: '500',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    '& .MuiInputBase-root': {
      height: '22px'
    },
    '& .MuiSelect-select': {
      paddingTop: '6px',
      paddingBottom: '6px'
    }
  },
  selectInvoice: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderBottom: '1px solid gray',
    maxWidth: 300,
    fontSize: '14px'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px',
    fontWeight: '500'
  },
  checkbox: {
    marginTop: theme.spacing(1),
    fontSize: '15px',
    color: '#808080'
  },
  progress: {
    flexGrow: 1
  },
  radioButton: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    marginTop: '0px',
    marginLeft: '20px',
    marginRight: '-21px',
    color: '#808080'
  },
  unselectButton: {
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      margin: '16px auto',
      float: 'left',
      width: '100%'
    }
  },
  newAllowanceForm: {
    display: 'flex',
    gap: '8px'
  },
  destinationDateField: {
    whiteSpace: 'nowrap',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '40%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '35%'
    }
  },
  destinationTimeField: {
    whiteSpace: 'nowrap',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '25%'
    }
  },
  kilometerAllowanceForm: {
    marginLeft: '-15px',
    display: 'flex',
    whiteSpace: 'nowrap',
    gap: '18px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '100%',
      gap: '0px'
    }
  },
  kilometerAllowanceField: {
    flex: 1,
    minWidth: '0',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  dailyFoodAllowanceForm: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '18px',
    marginLeft: '-24px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '100%'
    }
  },
  foodAllowanceField: {
    flex: 1,
    minWidth: '0',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0
    }
  },
  additionalCheckbox: {
    marginTop: theme.spacing(1),
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080',
    padding: '0 10px'
  },
  googleLogo: {
    margin: '16px 15px 0px 0px',
    maxHeight: '16px'
  },
  fieldContainer: {
    [theme.breakpoints.up('md')]: {
      width: '230px',
      overflow: 'hidden'
    },
    [theme.breakpoints.down('sm')]: {
      flexBasis: '95%',
      maxWidth: '80%'
    }
  }
})

const mileageDefaults = {
  distance: '',
  license_plate: '',
  vehicle_type: 'default_vehicle_type',
  allowancePassenger: [],
  forest_trail: false,
  heavy_load: false,
  working_dog: false,
  additional_vehicle_cost: 'default_additional_vehicle_cost'
}

export const defaultValues = {
  destination: '',
  country: '1',
  start_date: new Date(),
  end_date: new Date(),
  start_time: new Date(),
  end_time: new Date(),
  allowanceInputRow: [
    {
      route: ''
    },
    {
      route: ''
    }
  ],
  mileage_allowance: false,
  ...mileageDefaults,
  day_allowance: false,
  full_time_allowance: 0,
  part_time_allowance: 0,
  meal_allowance: 0,
  consent: false,
  decisionSelect: '',
  startPlace: [
    {
      route: ''
    }
  ],
  endPlace: [
    {
      route: ''
    }
  ]
}

const NewAllowance = ({
  classes,
  //id,
  allowanceCost,
  vehicleTypeItems,
  vehicleAdditionalItems,
  saveAllowance,
  showSpinner,
  //showSnackbar,
  //closeSnackbar,
  //showFailSnackbar,
  isEdit,
  saveAllowanceUpdate,
  enable_allowance_back_btn,
  cancelAllowanceUpdate,
  clearAdditionalVehicleInfo,
  countryList,
  invoiceFormValues,
  editAndGoToInvoice,
  loadAllowanceCost,
  start_date,
  //errMessage,
  location,
  showTravelCostsInfo,
  isReadOnly,
  allowanceEdit
}) => {
  const history = useHistory()
  const form = useForm({
    name: 'allowance',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: allowanceValidate,
    mode: 'onChange',
    resetOnSubmit: false
  })

  const {
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { isSubmitting, errors }
  } = form

  function onSubmit(values) {
    let formValues = { ...values }
    if (!formValues.day_allowance) {
      formValues.full_time_allowance = 0
      formValues.part_time_allowance = 0
      formValues.meal_allowance = 0
    }
    if (!formValues.mileage_allowance) {
      formValues = { ...formValues, ...mileageDefaults }
    }

    if (isEdit) {
      saveAllowanceUpdate(formValues)
    } else {
      saveAllowance(formValues)
    }
  }

  function clearMileageErrors(e) {
    if (!e.target.checked) {
      clearErrors([
        'distance',
        'license_plate',
        'vehicle_type',
        'allowancePassenger',
        'forest_trail',
        'heavy_load',
        'working_dog',
        'additional_vehicle_cost'
      ])
    }
  }

  function clearDayAllowanceErrors(e) {
    if (!e.target.checked) {
      clearErrors([
        'full_time_allowance',
        'part_time_allowance',
        'meal_allowance'
      ])
    }
  }

  const { decisionSelect } = useWatch({
    fields: ['decisionSelect'],
    control: control
  })

  // KAS-349 Taking the year cost at start date when edit the allowance
  React.useEffect(() => {
    if (isEdit) {
      loadAllowanceCost(new Date(start_date).getFullYear())
    } else {
      null
    }
  }, [isEdit, start_date])

  React.useEffect(() => {
    if (decisionSelect === 'add_to_invoice') {
      clearErrors(['distance'])
    }
  }, [decisionSelect])

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container-fluid">
            <div className="row">
              <div className="dashboard-content-header">
                {showTravelCostsInfo ? (
                  <h1>{t('newAllowComponent.h2')}</h1> // Travel costs info
                ) : isEdit ? (
                  <h1>{t('newAllowComponent.h1')}</h1> // Edit travel costs
                ) : (
                  <h1>{t('newAllowComponent.h1b')}</h1> // New travel cost
                )}
              </div>

              <Form {...form}>
                <div className="dashboard-content-header">
                  <div
                    className="col-xs-12 col-sm-12 col-lg-12"
                    style={{ padding: 0 }}
                  >
                    <div className="panel panel-default">
                      <div
                        className="panel-heading"
                        style={{
                          textAlign: 'left',
                          paddingLeft: '26px'
                        }}
                      >
                        <h3 className="panel-title">
                          {t('newAllowComponent.h3b')}
                        </h3>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '14px',
                          marginLeft: '17px'
                        }}
                      >
                        <div
                          className={classes.fieldContainer}
                          style={{ maxWidth: '300px' }}
                        >
                          <Field
                            name="destination"
                            inputType="textfield"
                            control={control}
                            label={t('newAllowComponent.label2') + ' *'}
                            disabled={isReadOnly}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                            autoFocus
                          />
                        </div>
                        <div className={classes.fieldContainer}>
                          <CountrySelectField
                            classes={classes}
                            countryList={countryList}
                            control={control}
                            disabled={isReadOnly}
                          />
                        </div>

                        <div className={classes.newAllowanceForm}>
                          <div
                            className={classes.destinationDateField}
                            style={{
                              flex: mobileView ? '1 1 100%' : '7 1 0%',
                              minWidth: '0',
                              maxWidth: '128px'
                            }}
                          >
                            <WatchField control={control} fields="end_date">
                              {(watch) => (
                                <Field
                                  name="start_date"
                                  inputType="datepicker"
                                  control={control}
                                  disabled={isReadOnly}
                                  label={t('newAllowComponent.label4a')}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                  maxDate={watch.end_date}
                                  onChange={(e) => {
                                    loadAllowanceCost(new Date(e).getFullYear())
                                  }}
                                  showCalendarIcon
                                />
                              )}
                            </WatchField>
                          </div>
                          <div
                            className={classes.destinationTimeField}
                            style={{
                              flex: mobileView ? '1 1 100%' : '3 1 0%',
                              marginRight: mobileView ? '12px' : '0px',
                              minWidth: '0',
                              maxWidth: '72px',
                              marginTop: '16px'
                            }}
                          >
                            <Field
                              name="start_time"
                              inputType="timepicker"
                              control={control}
                              disabled={isReadOnly}
                              //label={t('newAllowComponent.label5')}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          </div>
                        </div>
                        <div className={classes.newAllowanceForm}>
                          <div
                            className={classes.destinationDateField}
                            style={{
                              flex: mobileView ? '1 1 100%' : '7 1 0%',
                              minWidth: '0',
                              maxWidth: '128px'
                            }}
                          >
                            <WatchField control={control} fields="start_date">
                              {(watch) => (
                                <Field
                                  name="end_date"
                                  inputType="datepicker"
                                  control={control}
                                  label={t('newAllowComponent.label6a')}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                  minDate={watch.start_date}
                                  disabled={isReadOnly}
                                  showCalendarIcon
                                />
                              )}
                            </WatchField>
                          </div>
                          <div
                            className={classes.destinationTimeField}
                            style={{
                              flex: mobileView ? '1 1 100%' : '3 1 0%',
                              paddingRight: mobileView ? '16px' : '0px',
                              minWidth: '0',
                              maxWidth: mobileView ? '88px' : '72px',
                              marginTop: '16px'
                            }}
                          >
                            <Field
                              name="end_time"
                              inputType="timepicker"
                              control={control}
                              disabled={isReadOnly}
                              //label={t('newAllowComponent.label7')}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <AllowanceRoutes
                        classes={classes}
                        control={control}
                        getValues={getValues}
                        disabled={isReadOnly}
                      />
                    </div>

                    <div className="row" id="distance-scroll-section">
                      <div className="col-xs-12 col-sm-12 col-lg-12">
                        <div className="panel panel-default">
                          {/* Allowances */}
                          <div
                            className="panel-heading"
                            style={{ textAlign: 'left', paddingLeft: '26px' }}
                          >
                            <h3 className="panel-title">
                              {t('newAllowComponent.h3c')}
                            </h3>
                          </div>
                          <div
                            className="panel-body pd-0"
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              marginLeft: '16px'
                            }}
                          >
                            <div
                              style={{
                                flex: mobileView ? '1 1 100%' : '1 1 50%',
                                boxSizing: 'border-box',
                                textAlign: 'left'
                              }}
                            >
                              <Field
                                name="mileage_allowance"
                                label={t('newAllowComponent.label8')}
                                inputType="checkbox"
                                control={control}
                                className={classes.checkbox}
                                onChange={clearMileageErrors}
                                disabled={isReadOnly}
                              />
                            </div>
                            <div
                              style={{
                                flex: mobileView ? '1 1 100%' : '1 1 50%',
                                boxSizing: 'border-box',
                                textAlign: 'left'
                              }}
                            >
                              <Field
                                name="day_allowance"
                                label={t('newAllowComponent.label9')}
                                inputType="checkbox"
                                control={control}
                                className={classes.checkbox}
                                onChange={clearDayAllowanceErrors}
                                disabled={isReadOnly}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: mobileView ? 'column' : 'row'
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            {payMileage(
                              classes,
                              vehicleTypeItems,
                              vehicleAdditionalItems,
                              clearAdditionalVehicleInfo,
                              control,
                              location,
                              isReadOnly
                            )}
                          </div>
                          <div
                            style={{
                              flex: 1
                            }}
                          >
                            <DayAllowance
                              classes={classes}
                              control={control}
                              setValue={setValue}
                              location={location}
                              isReadOnly={isReadOnly}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {summary(allowanceCost, control)}
                <div
                  className="panel panel-default"
                  style={{
                    marginRight: '20px',
                    padding: 0
                  }}
                >
                  {/*    <div className="panel-heading">
                  <h3 className="panel-title">
                    {t('decisionDialog.dialogTitle1')}
                  </h3>
                </div> */}
                  <AddToInvoice
                    classes={classes}
                    type="newAllowance"
                    control={control}
                    disabled={isReadOnly}
                    isEditAllowance={isEdit}
                    allowanceEdit={allowanceEdit}
                  />

                  <Consent
                    classes={classes}
                    control={control}
                    invoiceItemType="allowance"
                    disabled={isReadOnly}
                  />
                  <SubmitButton
                    classes={classes}
                    isEdit={isEdit}
                    cancelAllowanceUpdate={cancelAllowanceUpdate}
                    enable_allowance_back_btn={enable_allowance_back_btn}
                    isSubmitting={isSubmitting}
                    errors={errors}
                    invoiceFormValues={invoiceFormValues}
                    editAndGoToInvoice={editAndGoToInvoice}
                    history={history}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </Form>

              {/* <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={showSnackbar}
                autoHideDuration={2000}
                onClose={() => {
                  closeSnackbar()
                  history.push('/dashboard/fee')
                }}
              >
                <MySnackbarContentWrapper
                  onClose={() => {
                    closeSnackbar()
                    history.push('/dashboard/fee')
                  }}
                  variant="success"
                  message={t('newAllowComponent.msg')}
                />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
                }}
                open={showFailSnackbar}
                autoHideDuration={2000}
                onClose={() => {
                  //store.dispatch(editAllowance(null, id)) --> NOT needed: commenting out because 'id' passed is always undefined (retaining for future reference)
                  closeSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  onClose={() => {
                    //store.dispatch(editAllowance(null, id))
                    closeSnackbar()
                  }}
                  variant="error"
                  message={
                    errMessage ===
                    'Error: Miles allowances box checked, and no vehicle type was selected'
                      ? t('newAllowComponent.vehicleFailMsg')
                      : t('newAllowComponent.failMsg')
                  }
                />
              </Snackbar> */}
              <Dialog
                open={showSpinner}
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{ fontSize: '15px', margin: '20px' }}
                  >
                    {t('newAllowComponent.title')}
                  </DialogContentText>
                </DialogContent>
                <div className={classes.progress}>
                  <LinearProgress />
                </div>
              </Dialog>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const summary = (allowanceCost, control) => (
  <Translation>
    {() => {
      return (
        <div className="row">
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div className="panel panel-default">
                {/*  <div className="panel-heading">
                  <h3 className="panel-title">{t('newAllowComponent.h3d')}</h3>
                </div> */}
                <div
                  className="panel-body pd-0"
                  style={{
                    paddingRight: mobileView ? '0px' : '16px',
                    paddingLeft: mobileView ? '0px' : '16px'
                  }}
                >
                  <div
                    style={{
                      border: '1px solid #ebf9fa',
                      borderTop: '1px solid #44c0cc'
                    }}
                  >
                    <SummaryTableComponent
                      allowanceCost={allowanceCost}
                      control={control}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)

const AllowanceRoutes = ({ classes, control, getValues, disabled }) => {
  const dispatch = useDispatch()
  const { fields, append, remove } = useFieldArray({
    name: 'startPlace',
    control
  })
  const { fields: endPlaceField } = useFieldArray({
    name: 'endPlace',
    control
  })

  function handleRemove(index) {
    remove(index)
  }

  function handleAdd() {
    append({ route: '' })
  }

  function handleCalculateDistance() {
    const formValues = getValues()
    dispatch(calculateDistance(formValues))
    //scrollToTarget('distance-scroll-section', -120)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="row" style={{ padding: '15px' }}>
            <div>
              {generateRouteStops(
                control,
                fields,
                handleRemove,
                handleAdd,
                disabled
              )}
              <div
                className="col-xs-12 col-sm-12 col-md-3 col-lg-2"
                style={{ marginRight: '50px' }}
              >
                <div
                  style={{
                    marginTop: '21px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={handleAdd}
                  >
                    {t('newAllowComponent.label10')}
                  </Button>
                </div>
              </div>
              {fields.length > 1 || mobileView ? (
                <div className="row" style={{ padding: '10px' }}></div>
              ) : null}
              {generateEndPlace(t, control, classes, endPlaceField, handleAdd, disabled)}
              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <div style={{ marginTop: '21px' }}>
                  <Button
                    variant="contained"
                    className={classes.button}
                    disabled={disabled}
                    onClick={handleCalculateDistance}
                  >
                    {t('newAllowComponent.calculateDist')}
                  </Button>
                </div>
              </div>
            </div>
            <div>
              <img
                className={classNames('pull-right', classes.googleLogo)}
                src={poweredByGoogle}
              />
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const generateRouteStops = (control, fields, remove, handleAdd, disabled) => {
  return fields.map((field, index) => (
    <AllowanceRoute
      key={field.id}
      index={index}
      remove={remove}
      disabled={disabled}
      control={control}
      type={index === 0 ? 'start' : 'stop'}
      handleAdd={handleAdd}
      fields={fields}
    />
  ))
}

const generateEndPlace = (
  t,
  control,
  classes,
  endPlaceField,
  handleAdd,
  disabled
) => {
  return endPlaceField.map((el, index) => (
    <div
      key={el.id}
      className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
      style={{
        paddingRight: '14px'
      }}
    >
      <Field
        name={`endPlace.${index}.route`}
        label={t('newAllowRow.endLabel')}
        placeholder={t('newAllowRow.endLabel')}
        inputType="autocomplete-places"
        control={control}
        className={classNames(classes.textField2, classes.resize)}
        disabled={disabled}
      />
    </div>
  ))
}


export const payMileage = (
  classes,
  vehicleTypeItems,
  vehicleAdditionalItems,
  clearAdditionalVehicleInfo,
  control,
  location,
  isReadOnly
) => (
  <WatchField control={control} fields="mileage_allowance">
    {(watch) =>
      !watch.mileage_allowance ? null : (
        <Translation>
          {(t) => {
            return (
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div
                    className={
                      location === '/dashboard/fee/newallowance'
                        ? 'panel panel-default'
                        : ''
                    }
                  >
                    {location === '/dashboard/fee/newallowance' ? (
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('newAllowComponent.h3f')}
                        </h3>
                      </div>
                    ) : null}
                    <div className="panel-body">
                      <div
                        className={classes.kilometerAllowanceForm}
                        style={{ marginTop: '-34px' }}
                      >
                        <div className={classes.kilometerAllowanceField}>
                          <Field
                            name="distance"
                            inputType="textfield"
                            control={control}
                            label={t('newAllowComponent.label11')}
                            disabled={isReadOnly}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                            inputComponent={GenericNumberInput}
                          />
                        </div>
                        <div className={classes.kilometerAllowanceField}>
                          <Field
                            name="license_plate"
                            inputType="textfield"
                            control={control}
                            label={t('newAllowComponent.label12')}
                            disabled={isReadOnly}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                          />
                        </div>
                      </div>
                      <div className={classes.kilometerAllowanceForm}>
                        <div className={classes.kilometerAllowanceField}>
                          <Field
                            name="vehicle_type"
                            inputType="select"
                            control={control}
                            className={classes.select}
                            label={t('newAllowComponent.label13')}
                            disabled={isReadOnly}
                            onChange={(e) => {
                              if (e.target.value !== 'own_car') {
                                clearAdditionalVehicleInfo()
                              }
                            }}
                          >
                            {vehicleTypeItems}
                          </Field>
                        </div>
                        <div className={classes.kilometerAllowanceField}>
                          {/*there must be hidden block to prevent table vanishing when additional info is not shown*/}
                          <WatchField control={control} fields="vehicle_type">
                            {(watch) =>
                              watch.vehicle_type !== 'own_car' ? (
                                <div style={{ visibility: 'hidden' }}>
                                  {t('newAllowComponent.div')}
                                </div>
                              ) : (
                                additionalInfo(
                                  classes,
                                  vehicleAdditionalItems,
                                  control,
                                  isReadOnly
                                )
                              )
                            }
                          </WatchField>
                        </div>
                      </div>
                      {/* own_car checkbox lists */}
                      <WatchField control={control} fields="vehicle_type">
                        {(watch) =>
                          watch.vehicle_type !== 'own_car' ? (
                            <div style={{ visibility: 'hidden' }}>
                              {t('newAllowComponent.div')}
                            </div>
                          ) : (
                            <div
                              style={{
                                marginTop: '15px'
                              }}
                            >
                              <Field
                                name="heavy_load"
                                label={t('newAllowComponent.label16')}
                                disabled={isReadOnly}
                                inputType="checkbox"
                                control={control}
                                className={classes.additionalCheckbox}
                              />
                              <Field
                                name="forest_trail"
                                label={t('newAllowComponent.label17')}
                                disabled={isReadOnly}
                                inputType="checkbox"
                                control={control}
                                className={classes.additionalCheckbox}
                              />
                              <Field
                                name="working_dog"
                                label={t('newAllowComponent.label18')}
                                disabled={isReadOnly}
                                inputType="checkbox"
                                control={control}
                                className={classes.additionalCheckbox}
                              />
                            </div>
                          )
                        }
                      </WatchField>
                    </div>
                    <div>
                      <PassengerList
                        t={t}
                        classes={classes}
                        control={control}
                        isReadOnly={isReadOnly}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          }}
        </Translation>
      )
    }
  </WatchField>
)

const PassengerList = ({ t, classes, control, isReadOnly }) => {
  const [addingRow, setAddingRow] = React.useState(false)

  const { fields, append, remove } = useFieldArray({
    name: 'allowancePassenger',
    control: control
  })

  function addRow() {
    append({ passenger: '' })
    setAddingRow(true)
  }

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableBody>
          {fields.map((field, index) => (
            <AllowancePassenger
              key={field.id}
              index={index}
              control={control}
              remove={remove}
              addingRow={addingRow}
              setAddingRow={setAddingRow}
              isReadOnly={isReadOnly}
            />
          ))}
        </TableBody>
      </Table>
      <WatchField control={control} fields="vehicle_type">
        {(watch) => (
          <div className="nav nav-pills" style={{ display: 'flex' }}>
            <Button
              variant="contained"
              className={classes.button1}
              onClick={addRow}
              disabled={
                isReadOnly || watch.vehicle_type === 'default_vehicle_type'
              }
              style={{
                marginLeft: mobileView ? 'auto' : '348px',
                marginTop: '10px'
              }}
            >
              {t('newAllowComponent.label14')}
            </Button>
          </div>
        )}
      </WatchField>
    </div>
  )
}

const additionalInfo = (
  classes,
  vehicleAdditionalItems,
  control,
  isReadOnly
) => (
  <Translation>
    {(t) => {
      return (
        <div>
          <div>
            <Field
              name="additional_vehicle_cost"
              inputType="select"
              control={control}
              disabled={isReadOnly}
              label={t('newAllowComponent.label15')}
              className={classes.select}
            >
              {vehicleAdditionalItems}
            </Field>
          </div>
        </div>
      )
    }}
  </Translation>
)

export const DayAllowance = ({
  control,
  classes,
  setValue,
  location,
  isReadOnly
}) => {
  const {
    start_date,
    start_time,
    end_date,
    end_time,
    day_allowance,
    ...allowances
  } = useWatch({
    fields: [
      'start_date',
      'start_time',
      'end_date',
      'end_time',
      'day_allowance',
      'full_time_allowance',
      'part_time_allowance',
      'meal_allowance'
    ],
    control: control
  })

  const [updateAllowanceFull, setUpdateAllowanceFull] = React.useState()
  const [updateAllowancePart, setUpdateAllowancePart] = React.useState()
  const [updateAllowanceMeal, setUpdateAllowanceMeal] = React.useState()

  const { days, hours } = getDaysAndHours(
    start_date,
    end_date,
    start_time,
    end_time
  )
  const allowanceFullValue = getFullDayAllowanceValues(days, hours, allowances)
  const allowancePartValue = getPartDayAllowanceValues(days, hours, allowances)
  const allowanceMealValue = getMealAllowanceValues(days, hours, allowances)

  React.useEffect(() => {
    if (updateAllowanceFull > allowanceFullValue) {
      setValue('full_time_allowance', 0)
      setUpdateAllowanceFull(null)
    }
  }, [
    updateAllowanceFull,
    setUpdateAllowanceFull,
    allowanceFullValue,
    setValue
  ])

  React.useEffect(() => {
    if (updateAllowancePart > allowancePartValue) {
      setValue('part_time_allowance', 0)
      setUpdateAllowancePart(null)
    }
  }, [
    updateAllowancePart,
    setUpdateAllowancePart,
    allowancePartValue,
    setValue
  ])

  React.useEffect(() => {
    if (updateAllowanceMeal > allowanceMealValue) {
      setValue('meal_allowance', 0)
      setUpdateAllowanceMeal(null)
    }
  }, [
    updateAllowanceMeal,
    setUpdateAllowanceMeal,
    allowanceMealValue,
    setValue
  ])

  return !day_allowance ? null : (
    <Translation>
      {(t) => {
        return (
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div
                className={
                  location === '/dashboard/fee/newallowance'
                    ? 'panel panel-default'
                    : ''
                }
              >
                {location === '/dashboard/fee/newallowance' ? (
                  <div className="panel-heading">
                    <h3 className="panel-title">
                      {t('newAllowComponent.h3g')}
                    </h3>
                  </div>
                ) : null}
                <div className="panel-body">
                  <div
                    className={classes.dailyFoodAllowanceForm}
                    style={{ marginTop: '-34px' }}
                  >
                    <div
                      className={classes.foodAllowanceField}
                      style={{ marginLeft: mobileView ? '12px' : '0px' }}
                    >
                      <Field
                        name="full_time_allowance"
                        inputType="select"
                        control={control}
                        label={t('newAllowComponent.float')}
                        className={classes.select}
                        style={{ width: '100%' }}
                        disabled={isReadOnly}
                        renderValue={(value) => {
                          if (value > allowanceFullValue) {
                            setUpdateAllowanceFull(value)
                          }
                          return <>{value}</>
                        }}
                      >
                        {createMenuItems(allowanceFullValue)}
                      </Field>
                    </div>
                    <div
                      className={classes.foodAllowanceField}
                      style={{ marginLeft: mobileView ? '12px' : '0px' }}
                    >
                      <Field
                        name="part_time_allowance"
                        inputType="select"
                        control={control}
                        style={{ width: '100%' }}
                        disabled={isReadOnly}
                        label={t('newAllowComponent.float2')}
                        className={classes.select}
                        renderValue={(value) => {
                          if (value > allowancePartValue) {
                            setUpdateAllowancePart(value)
                          }
                          return <>{value}</>
                        }}
                      >
                        {createMenuItems(allowancePartValue)}
                      </Field>
                    </div>
                    <div
                      className={classes.foodAllowanceField}
                      style={{ marginLeft: mobileView ? '12px' : '0px' }}
                    >
                      <Field
                        name="meal_allowance"
                        inputType="select"
                        control={control}
                        style={{ float: 'right', width: '100%' }}
                        disabled={isReadOnly}
                        label={t('newAllowComponent.float3')}
                        className={classes.select}
                        renderValue={(value) => {
                          if (value > allowanceMealValue) {
                            setUpdateAllowanceMeal(value)
                          }
                          return <>{value}</>
                        }}
                      >
                        {createMenuItems(allowanceMealValue)}
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const SubmitButton = ({
  classes,
  isEdit,
  cancelAllowanceUpdate,
  enable_allowance_back_btn,
  isSubmitting,
  errors,
  history,
  isReadOnly
}) => {
  const [submitFailed, setSubmitFailed] = React.useState(false)
  const [attemptingSubmit, setAttemptingSubmit] = React.useState(false)

  React.useEffect(() => {
    if (attemptingSubmit && !isEmpty(errors)) {
      setSubmitFailed(true)
      setAttemptingSubmit(false)
    }
  }, [attemptingSubmit, setSubmitFailed, errors])

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <div className="row" style={{ marginRight: '-1px' }}>
              <div className="pull-right">
                {isEdit ? (
                  !isReadOnly && (
                    <ul className="nav nav-pills pull-right">
                      <li>
                        <Button
                          variant="outlined"
                          className={classes.editButton}
                          onClick={() => {
                            cancelAllowanceUpdate()
                            history.push('/dashboard/fee')
                          }}
                        >
                          {t('newAllowComponent.label19')}
                        </Button>
                      </li>
                      <li>
                        <Button
                          variant="contained"
                          className={classes.editButton}
                          type="submit"
                          disabled={isSubmitting}
                          onClick={() => {
                            if (!isEmpty(errors)) {
                              setSubmitFailed(true)
                            }
                          }}
                        >
                          {t('newAllowComponent.label20')}
                        </Button>
                      </li>
                    </ul>
                  )
                ) : (
                  <>
                    {enable_allowance_back_btn ? (
                      <>
                        <Button
                          variant="contained"
                          className={classes.button}
                          type="submit"
                          disabled={isSubmitting}
                          onClick={() => {
                            if (!isEmpty(errors)) {
                              setSubmitFailed(true)
                            }
                          }}
                        >
                          {t('newAllowComponent.label21')}
                        </Button>
                      </>
                    ) : (
                      <Button
                        variant="contained"
                        className={classes.button}
                        type="submit"
                        disabled={isSubmitting}
                        onClick={() => {
                          setAttemptingSubmit(true)
                        }}
                      >
                        {t('newAllowComponent.label21')}
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={submitFailed && !isEmpty(errors)}
              autoHideDuration={2000}
            >
              <MySnackbarContentWrapper
                noCloseIcon={true}
                variant="error"
                message={t('newAllowComponent.msg2')}
              />
            </Snackbar>
          </>
        )
      }}
    </Translation>
  )
}

NewAllowanceComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewAllowanceComponent)
